import React,{Component} from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import { ListItemText } from '@material-ui/core';
 
export default class CgSelect extends Component {
    constructor(props){
        super(props);

        this.onChange = this.onChange.bind(this);
        this.convertValue = this.convertValue.bind(this);
    }
  onChange(value){
    if(!value){
        this.props.onChange(null);
    }
    if(this.props.isMulti){
        this.props.onChange(value.join(';'));
    }else{
        this.props.onChange(value);
    }
  }
  convertValue(){
      if(this.props.isMulti){
          return this.props.value?this.props.value.split(';'):[];
      } else {
          return this.props.value ? this.props.value:'';
      }
  }
  render() {
      const {style} = this.props;
    return (
        <Select 
            style={style}
            multiple={this.props.isMulti === true}
            value={this.convertValue()}
            onChange={event => this.onChange(event.target.value)}
            renderValue={value => this.props.isMulti?value.join(';'):value}
            displayEmpty={true}
          >
          {
            this.props.options.map(p => (
                this.props.isMulti?(
                    <MenuItem key={p} value={p}>
                        <Checkbox checked={this.convertValue().indexOf(p) > -1} />
                        <ListItemText primary={p}/>
                    </MenuItem>
                ):(
                    <MenuItem key={p} value={p}>{p}</MenuItem>
                )
            ))
          }
        </Select>
    );
  }
}